export const CONSTANTS = {
  GRAVITY: 0.55,
  JUMP_VELOCITY: -15.6,
  BASE_SPEED: 2.6,
  SPRINT_SPEED: 4.2,
  WORLD_WIDTH: 4000,
  PLAYER_HITBOX_WIDTH: 36,
  PLAYER_HITBOX_HEIGHT: 56,
  STONE_SIZE_X: 20,
  STONE_SIZE_Y: 16,
  STONE_VX: 8,
  STONE_VY: 0,
  STONE_GRAVITY: 0.1,
  STONE_LIFETIME: 120,
  STONE_COOLDOWN: 18,
  STONE_MAX_ACTIVE: 8,
  PIT_THRESHOLD: 700,
  PIT_DAMAGE: 20,
  COYOTE_TIME: 100,
  JUMP_BUFFER_TIME: 100,
  DOUBLE_JUMP_RATIO: 0.9,
  RELEASED_JUMP_VELOCITY: -5,
  DAMAGE_INVULNERABILITY: 800,
  TERMINAL_VELOCITY: 15,
  ECOFLOW_INVULNERABILITY: 4000,
  USD_TO_CUP: 500,
  EUR_TO_CUP: 600,
  ACCELERATION: 0.3,
  RUN_ACCELERATION: 0.5,
  FRICTION: 0.2,
  AIR_CONTROL: 0.15,
  CANVAS_WIDTH: 1280,
  CANVAS_HEIGHT: 720,
  ASPECT_RATIO: 16 / 9,
} as const;
